import Api from "@/services/api.js";
import Log from "@/services/log.js";
import router from "../../router";

var $ = require("jquery");
export default {
	data() {
		return {
			exibeDebug: false,
			token1: "",
			token2: "",
			token3: "",
			token4: "",
			erro: false,
			mensagem_erro: ""
		};
	},
	mounted() {
		let that = this;
		this.limpaLS();
		if (
			!this.$route.params.id ||
			document.referrer.indexOf("www.econeteditora.com.br") == -1
		) {
			window.location = "http://www.econeteditora.com.br";
		}
		new Api()
			.get("Login/ValidarLogin/" + this.$route.params.id)
			.then(response => {
				that.exibeLog("Login mounted Login/ValidarLogin", response);
				let token = response.dados.token;
				let nome_usuario = response.dados.nome_usuario;
				let primeiro_login = response.dados.primeiro_login;
				let usuario_pro = response.dados.usuario_pro;
				localStorage.setItem("token", token);
				localStorage.setItem("nome_usuario", nome_usuario);
				localStorage.setItem("primeiro_login", primeiro_login);
				localStorage.setItem("usuario_pro", usuario_pro);
				localStorage.setItem('verificarLP', true);
				localStorage.setItem('exibeLP', response.dados.exibe_lp);

				let ip = response.dados.ip;
				let id_usuario = response.dados.id_usuario;
				let email_usuario = response.dados.email_usuario;

				new Api()
					.get("Login/VerificaAlertas/" + id_usuario)
					.then(response => {
						localStorage.setItem("primeiro_login", primeiro_login);
						localStorage.setItem('exibeLP', response.dados.exibe_lp);
					});

				let obj = {
					strIP: ip,
					strAgente: navigator.userAgent,
					strMetodoHttp: 'GET',
					intIdUsuario: id_usuario,
					strNomeUsuario: nome_usuario,
					strLogin: email_usuario,
					strSenha: '-',
					blAcessoSistema: true,
				};
				new Log().reportLogin(obj);

				if (usuario_pro) {
					localStorage.removeItem("token");
					localStorage.removeItem("nome_usuario");
					this.showModalToken();
				} else {
					router.push({
						path: "/"
					});
					window.location = "/";
				}
			});
	},
	methods: {
		exibeLog: function(texto = '', valor = null) {
			if (this.exibeDebug) {
				if (valor != null) console.log(texto, valor);
				else console.log(texto);
			}
		},
		validarToken: function() {
			this.erro = false;
			var token = "" + this.token1 + this.token2 + this.token3 + this.token4;
			let postToken = {
				token: token
			};
			new Api()
				.post("Login/ValidarToken", postToken)
				.then(response => {
					that.exibeLog("Login validarToken Login/ValidarToken", response);
					localStorage.clear();
					let token = response.dados.token;
					let nome_usuario = response.dados.nome_usuario;
					let primeiro_login = response.dados.primeiro_login;
					let usuario_pro = response.dados.usuario_pro;
					localStorage.setItem("token", token);
					localStorage.setItem("nome_usuario", nome_usuario);
					localStorage.setItem("primeiro_login", primeiro_login);
					localStorage.setItem("usuario_pro", usuario_pro);
					window.location = "/";
				})
				.catch(response => {
					this.erro = true;
					this.mensagem_erro = "Token inválido! Verifique o token informado.";
					if (response.mensagem) {
						this.mensagem_erro = response.mensagem;
					}
				});
		},
		showModalToken: function() {
			this.$refs.modalToken.show();
			setTimeout(function() {
				$("input[name=input1]").focus();
			}, 300);
		},
		fecharAba: function() {
			this.limpaLS();
			window.location = "http://www.econeteditora.com.br";
		},
		limpaLS: function() {
			localStorage.removeItem("token");
			localStorage.removeItem("nome_usuario");
			localStorage.removeItem("primeiro_login");
			localStorage.removeItem("usuario_pro");
			localStorage.removeItem("exibe_lp");
			localStorage.removeItem("empresa");
			localStorage.removeItem("empresa_original");
		}
	}
};